import React from 'react';
import { IColumnsType } from '@revfluence/fresh';
import { formatValue, DataFormat } from '../../utils';
import { getLocaleString } from '../../utils/dateTimeUtils';
import { getCurrencySymbol } from '../../pages/LandingPage/utils/LandingPagePreviewUtils';

interface PayoutLineItem {
  id: string;
  name: string;
  payout: number;
  __typename?: string;
}

interface PayoutRuleData {
  ruleTitle: string;
  totalPayout: number;
  lineItems: PayoutLineItem[] | null;
  orderPlacedAt: Date;
  orderSubtotal: number;
  currency?: string;
  flatPayout?: number;
  percentPayout?: number;
  __typename?: string;
}

enum RuleConditionTypes {
  ORDER_SUBTOTAL = 'Order Subtotal',
  COLLECTIONS = 'Collections',
  PRODUCTS = 'Products',
  DURATION = 'Duration',
  RECURRING = 'Recurring',
  DEFAULT = 'Default',
}

export const payoutBreakdownColumns: IColumnsType<PayoutRuleData> = [
  {
    title: 'Rule',
    dataIndex: 'ruleTitle',
    key: 'ruleTitle',
    render: (value: string) => RuleConditionTypes[value as keyof typeof RuleConditionTypes],
  },
  {
    title: 'Total Payout',
    dataIndex: 'totalPayout',
    key: 'totalPayout',
    render: (_: number, record: PayoutRuleData) => {
      const payoutCommission = record.flatPayout > 0 || record.percentPayout > 0 ? record.flatPayout ? `${getCurrencySymbol(record.currency || 'USD')}${formatValue(DataFormat.Money, record.flatPayout)}` : `${record.percentPayout}%` : 0;
      return `${payoutCommission}`;
    },
  },
  {
    title: 'Order Info',
    dataIndex: 'lineItems',
    key: 'lineItems',
    render: (_: PayoutLineItem[] | null, record: PayoutRuleData) => {
      if (!record.lineItems) return '-';
      const currencySymbol = getCurrencySymbol(record.currency || 'USD');

      return (
        <div className="space-y-2">
          {record.lineItems.map((item) => (
            <div key={item.id}>
              <div className="flex justify-between min-w-[50px]">
                <span className="pr-2">{item.name}:</span>
                <span>{currencySymbol}{formatValue(DataFormat.Money, item.payout)}</span>
              </div>
            </div>
          ))}
          {record.ruleTitle === 'DURATION' && record.orderPlacedAt && (
            <div className="flex justify-between">
              <span className="pr-2">Order Date:</span>
              <span>{getLocaleString(record.orderPlacedAt)}</span>
            </div>
          )}
          {record.ruleTitle === 'ORDER_SUBTOTAL' && (
            <div className="flex justify-between">
              <span className="pr-2">Order Subtotal:</span>
              <span>{currencySymbol}{formatValue(DataFormat.Money, record.orderSubtotal)}</span>
            </div>
          )}
          {record.ruleTitle === 'RECURRING' && (
            <div>
              <span className="font-bold">Yes</span>
            </div>
          )}
        </div>
      );
    },
  },
];
